import { Button, Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LinkComponent from 'modules/Services/NetworksList/subcomponents/Items/LinkComponent'
import HighRiskLabel from 'modules/Services/Network/subcomponents/HighRiskLabel'

const UnlinkedListItem = ({ type }) => {
  const { t } = useTranslation(['services'])

  return (
    <LinkComponent type={type}>
      <Grid
        gap={24}
        alignItems={'center'}
        direction={'column'}
        justifyContent={'end'}
      >
        <Grid
          wrap={false}
          direction={'row'}
          gap={16}
          alignItems={'center'}
        >
          <NetworkIcon
            rounded
            width={56}
            name={type}
            type={'unlinked'}
          />
          <Typography
            component={'div'}
            noMargin
            variant={'Subtitle-30'}
            color={'Label-Primary'}
          >
            {t(`networks.${type}`)}
          </Typography>
          {type.match(/high-risk$/) && <HighRiskLabel />}
        </Grid>
      </Grid>

      <Grid>
        <Button
          noHover
          variant={'primary'}
          bgColor={'Background-Dark'}
          grey
          size={'s'}
          opacity={10}
        >
          {t('button.connect')}
        </Button>
      </Grid>
    </LinkComponent>
  )
}

UnlinkedListItem.propTypes = {
  type: PropTypes.string,
}

export default UnlinkedListItem
